import SendMessageForm from "Forms/SendMessageForm";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";

class SendMessageModal extends Component {
  state = {
    fetching: false
  };

  handleSubmit = values => {
    this.setState({
      fetching: true
    });
  };

  render() {
    const { show, onHide } = this.props;
    const { fetching } = this.state;
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>Send Message</Modal.Header>
        <Modal.Body>
          <SendMessageForm
            handleSubmit={this.handleSubmit}
            fetching={fetching}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendMessageModal);
